import { Fragment } from "react";
import { Link } from "react-router-dom";
import { IconChevronRight } from "@tabler/icons-react";
import styles from "./Breadcrumb.module.css";
import Text from "./Text.tsx";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  if (items.length === 0) return null;

  const lastIndex = items.length - 1;

  return (
    <nav aria-label="Fil d'Ariane">
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isLast = index === lastIndex;
          const itemDisplay = (
            <Text color="neutral" variant="deci" as="span">
              {item.label}
            </Text>
          );
          return (
            <Fragment key={index}>
              <li aria-current={isLast ? "page" : undefined}>
                {item.to && !isLast ? (
                  <Link to={item.to} className={styles.link}>
                    {itemDisplay}
                  </Link>
                ) : (
                  itemDisplay
                )}
              </li>
              {!isLast && (
                <IconChevronRight
                  size={16}
                  stroke={1.5}
                  className={styles.separator}
                  aria-hidden
                />
              )}
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
